import G1 from "modules/ebiForms/definitions/G1";
import G2 from "modules/ebiForms/definitions/G2";
import G3 from "modules/ebiForms/definitions/G3";
import G4 from "modules/ebiForms/definitions/G4";
import G5 from "modules/ebiForms/definitions/G5";
import G6 from "modules/ebiForms/definitions/G6";
import G7 from "modules/ebiForms/definitions/G7";
import G8 from "modules/ebiForms/definitions/G8";
import G9 from "modules/ebiForms/definitions/G9";
import { IEbiFormDefinition } from "modules/ebiForms/typings";

/** Geodezja i ochrona środowiska w starostwie: G1–G9 (docs/magistrat/ebi-wnioski). */
const FORMS: IEbiFormDefinition[] = [G1, G2, G3, G4, G5, G6, G7, G8, G9];

export default FORMS;
